import {createStore, applyMiddleware} from 'redux';
import reducers from '../app/redux/reducers';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import fetch from '../app/middleware/fetch';
const store = createStore(
	reducers,
	applyMiddleware(fetch, thunk, logger)
);

export default store;



// WEBPACK FOOTER //
// ./src/config/store.js